import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  value: {
    standardFormTypes: [],
    loaded: false
  }
};
const standardFormTypeSlice = createSlice({
  name: "standardFormTypes",
  initialState,
  reducers: {
    load: (state, action) => {
      console.log(action.payload);
      state.value = {
        standardFormTypes: action.payload,
        loaded: true
      };
    }
  }
});
export const { load } = standardFormTypeSlice.actions;
export default standardFormTypeSlice.reducer;
